export enum EffectivePolicySettingEnum {
  allowedNumOfBuilders = 'allowedNumOfBuilders',
  allowedConnectionsToProd = 'allowedConnectionsToProd',
  highNumberOfPrivilegedUsers = 'highNumberOfPrivilegedUsers',
  allowedConnectionsToNonProd = 'allowedConnectionsToNonProd',
  criticalNumberOfPrivilegedUsers = 'criticalNumberOfPrivilegedUsers',
  allowedNumOfPrivilegedIdentitiesInWorkspace = 'allowedNumOfPrivilegedIdentitiesInWorkspace',
  allowedNumOfPrivilegedIdentitiesToDashboard = 'allowedNumOfPrivilegedIdentitiesToDashboard',
  allowedNumOfPrivilegedIdentitiesToDataset = 'allowedNumOfPrivilegedIdentitiesToDataset',
  allowedNumOfPrivilegedIdentitiesToReport = 'allowedNumOfPrivilegedIdentitiesToReport',
  allowedNumOfPrivilegedIdentitiesToAgent = 'allowedNumOfPrivilegedIdentitiesToAgent',
  allowedNumOfPrivilegedIdentitiesToGpt = 'allowedNumOfPrivilegedIdentitiesToGpt',
  allowedNumOfPrivilegedIdentitiesToTable = 'allowedNumOfPrivilegedIdentitiesToTable',
  allowedMemoryRetentionInDays = 'allowedMemoryRetentionInDays',
  allowedMemoryMaxRecentSessions = 'allowedMemoryMaxRecentSessions',
  allowedNumOfPrivilegedIdentitiesToAiSkill = 'allowedNumOfPrivilegedIdentitiesToAiSkill',
  allowedIdentityProviders = 'allowedIdentityProviders',
  endpoints = 'endpoints',
  connectorList = 'connectorList',
  domainsList = 'domainsList',
  mcpServers = 'mcpServers',
}

export class RuleSummary {
  constructor(
    public id: string,
    public displayName: string
  ) {}
}

export class CategoryToRules {
  constructor(
    public category: string,
    public owaspCodeName: string,
    public rulesSummary: RuleSummary[]
  ) {}
}
